import ObjectId from "bson-objectid";
import { getDefaultColourScheme } from "../Colors/ColorPalettes";

const buildQuery = (DataArrayComponents) => {
  const query = { offset: 0 };
  DataArrayComponents.forEach((element) => {
    // console.log(element);
    // // console.log(element.valueType === "Number");
    // console.log(element.defaultValue);

    if (element.itemInArray) {
      query[element.reduxKey] = [];
    } else {
      query[element.reduxKey] = "";
    }
    if (element.valueType === "Number") {
      query[element.reduxKey] = element.defaultValue;
    }
  });

  return query;
};

const buildCustomization = (CustomizeArrayComponents) => {
  const customization = {};
  // console.log(CustomizeArrayComponents);

  CustomizeArrayComponents.forEach((element) => {
    // console.log(element);

    switch (element.type) {
      case "ICON":
      case "CONTAINER_WITH_TOGGLE":
        customization[element.reduxKey] = element.defaultValue;
        element.innerComponents.forEach((innerElement) => {
          customization[innerElement.reduxKey] = innerElement.defaultValue;
        });
        break;
      case "COLOR":
        // console.log("color is running");
        const schemeType = element.defaultType;
        const { id: colorSchemeID } = getDefaultColourScheme(schemeType);
        customization.colorSchemeType = schemeType;
        customization[element.reduxKey] = colorSchemeID;
        // console.log(colorSchemeID);
        break;
      default:
        // console.log(element.reduxKey);
        customization[element.reduxKey] = element.defaultValue;
        break;
    }
    //add item to the customization Object
  });

  // console.log(customization);
  return customization;
};

const buildIntialSheetState = (
  vizType,
  CustomizeArrayComponents,
  DataArrayComponents,
  receivedDataSourceID,
  sheetName
) => {
  // console.log(DataArrayComponents);
  // console.log(vizType);
  const dataSourceID = receivedDataSourceID || "66fe270945703a185f764d6c";
  // const dataSourceID = receivedDataSourceID || "66cbe8d9756fc0e0b46d1008";

  const ID = new ObjectId().toHexString();
  const SheetName = sheetName || "Sheet 1";
  const VizType = vizType;
  const sheetType = "chart";
  const isSheetVisible = true;

  const query = buildQuery(DataArrayComponents);
  // console.log(query);

  const customization = buildCustomization(CustomizeArrayComponents);
  const actions = {
    onClick: {
      _id: new ObjectId().toHexString(),
    },
    onDoubleClick: {
      _id: new ObjectId().toHexString(),
    },
    sort: [],
    quickTable: [],
  };
  const rowLimit = 500;
  // return staticSheet;
  return {
    ID,
    SheetName,
    VizType,
    sheetType,
    isSheetVisible,
    dataSourceID,
    query,
    customization,
    actions,
  };
};

export { buildIntialSheetState, buildCustomization };
